import type { FC } from 'react';

import type { IconProps } from './type';

export const StarOutlineIcon: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      height="22"
      viewBox="0 0 22 23"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="currentColor"
    >
      <path
        d="M6.535 18.956l4.48-2.843 4.481 2.88-1.173-5.387 3.947-3.592-5.192-.486-2.062-5.088-2.063 5.05-5.191.487 3.947 3.629-1.174 5.35zm-2.169 3.14l1.764-7.951L.266 8.799l7.724-.703 3.026-7.5 3.025 7.498 7.724.704-5.863 5.345 1.763 7.951-6.65-4.22-6.649 4.222z"
        fill="currentColor"
      />
    </svg>
  );
};
